// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HDVf","left":"styles_left__3fLwK"};